module.exports = __webpack_public_path__ + "static/media/trips-list-hero.a1a3273d.jpg";